import { useEffect } from "react";
import { useEndpoints } from "../../hooks/useEndpoints";
import { useSimpleForm } from "../../hooks/useSimpleForm";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import "./Register.scss";

export default function JoinOurTeam() {
  const navigate = useNavigate();
  const { me } = useSelector((st: RootState) => st.coachMe);
  const { registerCoach } = useEndpoints();
  const { form, handleEventInputChange } = useSimpleForm<
    Parameters<typeof registerCoach>[0]
  >({
    password: "",
    firstName: "",
    lastName: "",
    email: "",
  });

  useEffect(() => {
    if (me) navigate("/home");
    // eslint-disable-next-line
  }, []);

  const handleRegister = async () => {
    try {
      await registerCoach(form);
      navigate("/login");
    } catch (error) {
    }
  };

  return (
    <div className="register-page">
      <div className="register-page__container">
        <div className="register-page__intro">
          <h1 className="register-page__heading">
            Senior web designers <span className="accent">&amp;</span> Full-Stack
            Developers
          </h1>
          <p className="register-page__subtitle">
            Entra nella Beta Coach di Leopart
          </p>
        </div>

        <div className="register-page__form-card">
          <h2 className="register-page__form-title">
            Register<span className="accent">!</span>
          </h2>
          <p className="register-page__form-subtitle">
            Stiamo cercando ingegneri come te! Entra nel team Leopart.
          </p>

          <form
            className="register-page__form"
            onSubmit={(e) => {
              e.preventDefault();
              handleRegister();
            }}
          >
            <input
              type="text"
              className="register-page__input"
              value={form.firstName}
              onChange={(event) => handleEventInputChange("firstName", event)}
              placeholder="firstName"
              aria-label="Nome"
            />
            <input
              type="text"
              className="register-page__input"
              value={form.lastName}
              onChange={(event) => handleEventInputChange("lastName", event)}
              placeholder="lastName"
              aria-label="Cognome"
            />
            <input
              type="email"
              className="register-page__input"
              value={form.email}
              onChange={(event) => handleEventInputChange("email", event)}
              placeholder="email"
              aria-label="Email"
            />
            <input
              type="password"
              className="register-page__input"
              value={form.password}
              onChange={(event) => handleEventInputChange("password", event)}
              placeholder="password"
              aria-label="Password"
            />

            <span
              onClick={() => navigate("/login")}
              className="fake__link"
            >
              Sei già registrato? Allora accedi
            </span>

            <button
              type="submit"
              className="register-page__submit"
              onClick={handleRegister}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
